export default __webpack_public_path__ + "static/aubrey-aa648792718c71b4cfb469fa19ba81c5.jpg";